import * as React from 'react'
import cx from 'classnames'
import styles from './TableEmptyStateContainer.sass'

interface TableEmptyStateProps {
  /**
   * Adds a top border when true.
   */
  bordered?: boolean
  children?: React.ReactNode
}

/**
 * The TableEmptyState
 */
export default function TableEmptyState({
  children,
  bordered,
}: TableEmptyStateProps) {
  return (
    <div className={cx(styles.root, bordered && styles.bordered)}>
      {children}
    </div>
  )
}
